import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UseresUrl = `${Base_Url}/Notification`;

export const GetUserNotificationList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/GetUserNotificationList`,
    params
  );
  return res;
};

export const NotificationView = async (ModuleName, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/NotificationView?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}`
  );
  return res;
};
